import type { DatumEngine } from '@datum-sdk/engine';
import type { SceneMarker } from '../../shared/sceneContext';
import type { SightId } from '../../types';

/**
 * The chat context's "what is on screen" note, read off the SDK's marker roots:
 * `dsdk-is-hidden` means outside the frustum, `dsdk-is-occluded` a collider
 * between the camera and the POI (kernel `docs/poi-marker-theming.md`). A
 * clustered member stays visible, as legacy reported it.
 */
export const readSceneMarkers = (
  container: ParentNode,
  engine: Pick<DatumEngine, 'getCameraState' | 'getPoiById'>,
  sightIdByPoiId: ReadonlyMap<string, SightId>,
): SceneMarker[] => {
  const [cx, cy, cz] = engine.getCameraState().position;
  return Array.from(container.querySelectorAll('.dsdk-poi-marker[data-poi-id]'), (marker) => {
    const id = marker.getAttribute('data-poi-id') ?? '';
    const at = engine.getPoiById(id)?.position;
    return {
      // Nav beacons have no sight and go out as `nav:<target>`, as in legacy.
      sightId: sightIdByPoiId.get(id) ?? id,
      visible: !marker.classList.contains('dsdk-is-hidden'),
      occluded: marker.classList.contains('dsdk-is-occluded'),
      distance: at ? Math.hypot(at[0] - cx, at[1] - cy, at[2] - cz) : null,
    };
  });
};
